/**
 * View mode for asset explorer
 * Determines how assets are displayed in the tree
 */
export enum ViewMode {
  /**
   * Instance view - Shows actual asset instances with real data
   * Example: "TotalEnergies La Mède Refinery" → "Crude Distillation Unit (CDU-100)"
   */
  INSTANCE = 'instance',

  /**
   * Type view - Shows asset type hierarchy structure
   * Example: "Refinery" → "Unit" → "Tank" → "Flowmeter"
   */
  TYPE = 'type',
}
